export const ASSOCIATE_USER_LEVEL = 2; // 준회원 레벨
export const REGULAR_USER_LEVEL = 4; // 정회원 레벨
